import React from 'react'
import { Link } from 'react-router-dom'

export default function Okra() {
    return <>
        <div className="container-fluid bg-primary py-5 bg-frzn9 mb-5">
            <div className="container py-5">
                <div className="row justify-content-start">
                    <div className="col-lg-8 text-center text-lg-start">
                        <h1 className="display-1 text-white mb-md-4"> Frozen Okra (Zero Small)
                        </h1>
                        <Link to="/frozen-products" className="btn btn-primary py-md-3 px-md-5 me-3">Frozen Products </Link>
                        <Link to="" className="btn btn-secondary py-md-3 px-md-5"> Frozen Okra (Zero Small)
                        </Link>
                    </div>
                </div>
            </div>
        </div>

        <div className="container py-5">
            <div className='mb-5'>
                <h2 className='text-primary'>  Frozen Okra (Zero Small)
                </h2>
                <h5 className='text-muted'>Frozen okra is made from fresh, cleaned, and trimmed pods that are rapidly 
frozen to lock in their nutrients and freshness. This ensures availability 
throughout the year, making it a versatile ingredient for soups, stews, and stirfries, and is free from preservatives or chemicals.
                </h5>

            </div>

            <hr />
            <hr />

            <h2 className='text-primary my-3'>Packing</h2>

            <ul className='mb-5'>
                <li className="my-2">
                    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>- 1 x 10 kg / carton 

                    </h5>

                </li>
                <li className="my-2">
                    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>- 10 x 1 kg / carton 

                    </h5>

                </li>
                <li className="my-2">
                    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>- 4 x 2.5 kg / carton 
                
                    </h5>

                </li>
                <li className="my-2">
                    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'> - 20 x 400 g / carton 
                    </h5>

                </li>
            </ul>

            <hr />
            <hr />
            <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

        </div>
    </>
}
